import { useMutation } from '@tanstack/react-query';

import apiHelper from '@/apiHelper';
import { UpdateNookRequest } from '@/types/nook';

const useUpdateNookMutation = () => {
  return useMutation({
    mutationFn: async (data: UpdateNookRequest) => {
      const response = await apiHelper.put(`/api/nook/${data.nookId}`, data);
      return response.data?.data;
    },
  });
};

export default useUpdateNookMutation;
